export default class EntregaRetiradaUtils {

    static TIPO_ENTREGA = "ENTREGA";
    static TIPO_ENTREGA_OUTRO = "ENTREGA_OUTRO";
    static TIPO_RETIRADA = "RETIRADA";

}